export default __webpack_public_path__ + "static/media/velociraptor.d5479d9a.png";